// promos types
export default {
  UPDATE_ORDER_PAGES: 'UPDATE_ORDER_PAGES',
  GET_ORDERS_FOR_PAGE: 'GET_ORDERS_FOR_PAGE',
};
